// src/components/ui/CellLink/CellLink.jsx
import PropTypes from "prop-types"
import { cn } from "../../../lib/utils"

const SAFE_PROTOCOLS = new Set(["https:", "http:"])

function isSafeUrl(url) {
  try {
    return SAFE_PROTOCOLS.has(new URL(url).protocol)
  } catch {
    return false
  }
}

const baseClasses =
  "text-[var(--slate)] font-medium text-[13px] no-underline cursor-pointer border-none bg-transparent p-0 transition-colors duration-200 hover:text-[var(--brand-green)] hover:underline decoration-[var(--green-tint-border)]"

export default function CellLink({
  children,
  onClick,
  href,
  external,
  className,
  ...props
}) {
  // Block unsafe prop forwarding
  delete props.dangerouslySetInnerHTML

  if (href) {
    if (!isSafeUrl(href)) {
      return <span className={cn(baseClasses, className)}>{children}</span>
    }

    return (
      <a
        href={href}
        className={cn(baseClasses, "font-[var(--font-body)]", className)}
        data-app-table-row-click-ignore=""
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.stopPropagation()
          onClick?.(e)
        }}
        {...props}
      >
        {children}
      </a>
    )
  }

  return (
    <button
      type="button"
      className={cn(baseClasses, "font-[inherit]", className)}
      data-app-table-row-click-ignore=""
      onClick={(e) => {
        e.stopPropagation()
        onClick?.(e)
      }}
      {...props}
    >
      {children}
    </button>
  )
}

CellLink.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  href: PropTypes.string,
  external: PropTypes.bool,
  className: PropTypes.string,
  // dangerouslySetInnerHTML is intentionally blocked and never forwarded
  dangerouslySetInnerHTML: PropTypes.object,
}
